import React from "react";
import { useTranslation } from "react-i18next";
import "../classes/recommendations.css";

import ItemCard from "./ItemCard";
import { snacksData } from "../data/snacksData";

const SnacksCardList = () => {
  const { t, i18n } = useTranslation();
  const isTelugu = i18n.resolvedLanguage === "te";
  return (
    <section id="recommendation" className="recommendation">
      <div className="title">
        <h1>{t("snacksPage.heading")}</h1>
      </div>

      <div className="recommendationBox">
        {snacksData.map((item) => {
          const { name, nameTe, desc, descTe, price, quantity, image } = item;
          return (
            <ItemCard
              key={name}
              name={isTelugu ? nameTe : name}
              desc={isTelugu ? descTe : desc}
              price={price}
              quantity={quantity}
              image={image}
              showBtn={false}
              showOrderCta={true}
            />
          );
        })}
      </div>
    </section>
  );
};

export default SnacksCardList;
